<ul class="logbook-events-list" *ngIf="eventsList!=null && eventsList.length > 0">
  <project-details-logbook-events-list-item *ngFor="let event of eventsList | sortBy: 'date' : 'desc'" [event]="event"
    [activatedGroup]="activatedGroup" (selectGroup)="onSelectGroup($event)"></project-details-logbook-events-list-item>
</ul>

<div class="logbook-no-events" *ngIf="eventsList!=null && eventsList.length == 0">
  <ng-container  *ngIf="searching; else noEvents">
    <div class="no-results">
      <core-helpers-box-alert-message-icon
        [text]="'There are no matches for your query. Try removing filters or typing a new query.'"
        [icon]="'no_messages'"></core-helpers-box-alert-message-icon>
    </div>
  </ng-container>
  <ng-template #noEvents>
    <core-helpers-box-alert-message-icon [text]="'There are currently no events.'"
      [icon]="'no_messages'"></core-helpers-box-alert-message-icon>
  </ng-template>
</div>
